<div class="main-content">
    <div class="review-form">
        <div class="mb-1" *ngIf="triggeredFrom != 'edition' && !reviewTargetLocationForm.get('name').value">
            <p-autoComplete
                [(ngModel)]="selectedReviewTarget"
                [minLength]="1"
                [size]="30"
                [suggestions]="reviewSources"
                (completeMethod)="queryChange($event)"
                (onClear)="clear()"
                (onSelect)="selectedReviewSource($event)"
                emptyMessage="No results found"
                field="name"
                placeholder="Search review sites"
            >
                <ng-template let-reviewSources pTemplate="item">
                    <div class="ui-helper-clearfix">
                        {{reviewSources.name}}
                    </div>
                </ng-template>
            </p-autoComplete>
        </div>

        <h1 class="mb-1" *ngIf="triggeredFrom != 'edition' && reviewTargetLocationForm.get('name').value">
          {{ reviewTargetLocationForm.get('name').value }}
        </h1>

        <div *ngIf="!reviewTargetLocationForm.get('name').value" class="text-danger" style="font-size: 12px">
            Please select a review site on the list
        </div>

        <div class="mt-2 mb-3 rounded overflow-hidden" *ngIf="reviewTargetInfo.length && !isGoogle() && !isFacebook()">
            <div [innerHtml]="transformHtml(reviewTargetInfo)" class="wyswyg-ctr"></div>
        </div>

        <div class="d-sm-flex justify-content-center mb-3" *ngIf="isGoogle()">
            <div class="w-100" *ngIf="true | isGmbEnabled">
                <h4 *ngIf="triggeredFrom != 'edition' && !isGoogleBusinessArea(selectedReviewTarget.name)">Preferred Method</h4>

                <div
                    class="goog-list goog-list-login"
                    *ngIf="(!isGoogleSignedIn || error?.error?.includes('403')) | isGmbEnabled"
                >
                    <div>
                      <span>Connect your existing Google My Business account to our dashboard for the best support<!-- and exclusive features, like in-app review replying (coming soon)-->.</span>
                    </div>

                    <div class='gmb-err'>
                        {{error.error
                          ? error.error.includes("403")
                            ? "You have not granted all required permissions.
                          Please “Sign in with Google” again and ensure all permission boxes are checked."
                            : ''
                          : ''
                        }}
                    </div>

                    <div (click)="googleSignIn()">
                        <div class="goog-login goog-login-blue goog-login-fixed">
                            <div class="goog-login-content-wrapper">
                                <div class="goog-login-icon">
                                    <div class="goog-login-icon-image">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 48 48" class="goog-login-svg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                                    </div>
                                </div>

                                <span class="goog-login-contents">
                                    <span>Sign in with Google</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="goog-list"
                    *ngIf="isGoogleSignedIn && (googleMyBusinessListings || []).length > 0 && !error?.error?.includes('403')">
                    <div class="mb-2">
                        If you manage multiple businesses, select one from the list below:
                    </div>

                    <div *ngFor="let item of googleMyBusinessListings;"
                        class="card-goog"
                        [class.card-goog-selected]="item.id == selectedGoogleLocationId"
                        (click)="selectGoogleLocationId(item.id)">
                        <label class="page-name">{{item.title}}</label>
                        <label  class="google-addr" *ngIf="item.address!='' && item.address!=null">{{item.address}}</label>
                    </div>

                    <div class="goog-not-found-info mb-2">
                        <div style="font-size: 15px">
                            <span>
                               If the business you are looking for is not here try to
                            </span>
                            <span (click)="refreshGoogleMyBusinessListings.emit()" class="refresh-btn">
                                refresh</span>.
                            <span>
                                If it still does not appear, it may be associated with a different Google account.
                            </span>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label class="switch-account-goog" (click)="googleSignIn()">
                                Switch Google Accounts
                            </label>
                        </div>
                    </div>
                </div>
                <div class="goog-list goog-list-login" *ngIf="isGoogleSignedIn && (googleMyBusinessListings || []).length == 0">
                    <div class="goog-not-found-info">
                        <i class="fas fa-question"></i>
                        <div>
                            <span>
                                It seems the current Google account doesn't have any Google My Business listings associated with it, please try to
                            </span>
                            <span (click)="refreshGoogleMyBusinessListings.emit()" class="refresh-btn">
                                refresh
                            </span>
                            <span>
                                . If you believe this is an error, please contact support.
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="true | isFacebookEnabled" class="d-none d-sm-block goog-divider"></div>

            <div
                *ngIf="triggeredFrom != 'edition' && !isGoogleBusinessArea(selectedReviewTarget.name)"
                class="w-100 form-group"
            >
                <h4 *ngIf="(true | isGmbEnabled)">Alternate Method</h4>

                <label class="form-label" for="address">Business Name</label>

                <!-- <google-places-autocomplete
                    [placeholder]="'Enter a business name'"
                    (placeSelected)="addGooglePlaceId($event)">
                </google-places-autocomplete> -->

                <input
                    #placesRef="ngx-places"
                    ngx-google-places-autocomplete
                    class="form-input form-control"
                    placeholder="Enter a business name"
                    (onAddressChange)="addGooglePlaceId($event)"
                />

                <div class="info-ctn ng-star-inserted" *ngIf="reviewTargetInfo.length && isGoogle()">
                    <div [innerHtml]="transformHtml(reviewTargetInfo)" class="wyswyg-ctr"></div>
                </div>
            </div>
        </div>

        <div class="d-sm-flex justify-content-center mb-3" *ngIf="isFacebook()">
            <div class="w-100" *ngIf="true | isFacebookEnabled">
                <h4 *ngIf="triggeredFrom != 'edition'">Preferred Method</h4>

                <div
                    class="goog-list goog-list-login"
                    *ngIf="!facebookPages.length | isFacebookEnabled">
                    <div>
                      <span>Connect your existing Facebook account to our dashboard for the best support.</span>
                    </div>
                    <div (click)="loginToFacebook.emit()">
                        <div>
                            <div class="facebook-login-btn">
                              <div>
                                <div>
                                  <img class="facebook-circle-icon" src="../../../../assets/images/facebook-icon-circle.png">
                                </div>
                              </div>
                              <span class="facebook-login-txt">
                                <span>Log in with Facebook</span>
                              </span>
                          </div>
                        </div>
                    </div>
                </div>
                <div
                    class="goog-list"
                    *ngIf="facebookPages.length">
                    <div>
                        <span>Please select the page you want us to monitor recommendations</span>
                    </div>
                    <div *ngFor="let item of facebookPages;"
                        class="card-goog"
                        [class.card-goog-selected]="item.token.pageId == selectedFacebookPageId"
                        (click)="selectFacebookPageId(item)"
                        [disabled]="item.authFailure || item.premissionsFailure">
                        <label class="page-name">{{item.token.pageTitle}}</label>
                    </div>
                    <div (click)="loginToFacebook.emit()" *ngIf = "showContinueWthFacebookButton()">
                        <div>
                            <div class="facebook-login-btn">
                              <div>
                                <div>
                                  <img class="facebook-circle-icon" src="../../../../assets/images/facebook-icon-circle.png">
                                </div>
                              </div>
                              <span class="facebook-login-txt">
                                <span>Continue with Facebook</span>
                              </span>
                          </div>
                        </div>
                    </div>
                    <div *ngIf="showContinueWthFacebookButton()" class="goog-not-found-info">
                        <i class="fas fa-info"></i>
                        <div style="font-size: 15px">
                           Some of the pages are disabled due to authentication or permissions issues, if you want those to be enabled please resolve edit your permissions settings by clicking "Continue with Facebook"
                        </div>
                    </div>
                    <div class="goog-list goog-list-login" *ngIf="!facebookPages.length">
                        <div class="goog-not-found-info">
                            <i class="fas fa-question"></i>
                            <div>
                                <span>
                                    It seems the current Facebook account doesn't have any Pages associated with it, please try to. If you believe this is an error, please contact support.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label class="switch-account-goog" (click)="loginToFacebook.emit()">
                                Switch Facebook Accounts
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="triggeredFrom != 'edition' && true | isFacebookEnabled" class="d-none d-sm-block goog-divider"></div>

            <div *ngIf="triggeredFrom != 'edition'" class="w-100">
                <h4 *ngIf="(true | isFacebookEnabled)">Alternate Method</h4>

                <div *ngIf="reviewTargetInfo.length && !isGoogle()">
                    <div [innerHtml]="transformHtml(reviewTargetInfo)" class="wyswyg-ctr"></div>
                </div>
            </div>
        </div>

        <form *ngIf="reviewTargetLocationForm.get('name').value" [formGroup]="reviewTargetLocationForm" (ngSubmit)="onSubmit()">
            <div class="position-relative form-group mt-3">
                <label *ngIf="!isGoogle()" class="form-label form-label-required" for="url">
                    {{ isZillow() || isHouzz() ? "Review URL suffix" : "Suffix" }}
                </label>

                <div class="d-flex mt--1">
                    <label *ngIf="selectedReviewTarget?.prefix" class="prefix-site">
                        {{ selectedReviewTarget.prefix }}
                    </label>

                    <input
                        class="form-control input-suffix-site"
                        formControlName="url"
                        id="url"
                        name="url"
                        type="text"
                        [class.invalid-field]="reviewTargetLocationForm.get('url').dirty && reviewTargetLocationForm.get('url').invalid"
                        [placeholder]='isZillow() || isHouzz() ? "Enter review URL suffix" : "Enter URL suffix"'
                        [style.width]="suffixWidth ? suffixWidth : '100%'"
                    />
                </div>
            </div>

            <div *ngIf="isZillow() || isHouzz()" class="position-relative form-group mt-3">
                <label
                    class="form-label form-label-required mt-2"
                    for="callActionUrl"
                >
                    Campaign URL suffix
                </label>

                <div class="d-flex flex-column flex-sm-row text-nowrap mt--1">
                    <label
                        *ngIf="selectedReviewTarget?.prefix && isZillow()"
                        class="prefix-site campaign"
                    >
                        {{ selectedReviewTarget.prefix }}reviews/write/?s=
                    </label>

                    <label
                        *ngIf="selectedReviewTarget?.prefix && isHouzz()"
                        class="prefix-site campaign"
                    >
                        {{selectedReviewTarget.prefix.replace("/professionals/", "/writeProReview/").replace("/hznb","")}}cmd=r/n=
                    </label>

                    <input
                        class="form-control input-suffix-site"
                        formControlName="callActionUrl"
                        id="callActionUrl"
                        name="callActionUrl"
                        placeholder="Enter campaign URL suffix"
                        type="text"
                        [class.invalid-field]="reviewTargetLocationForm.get('callActionUrl').dirty && reviewTargetLocationForm.get('callActionUrl').invalid"
                    />
                </div>
            </div>

            <div *ngIf="triggeredFrom != 'edition'" class="d-flex flex-end w-100">
                <button
                    class="btn btn-primary mb-1"
                    type="submit"
                    [disabled]="!reviewTargetLocationForm.valid"
                >
                    Add Review Site
                </button>
            </div>
        </form>

        <div class="d-flex flex-end mb-1 w-100">
            <button
                *ngIf="triggeredFrom == 'edition'"
                class="btn btn-primary mb-1"
                type="button"
                [disabled]="!reviewTargetLocationForm.valid"
                (click)="onEdit()"
            >
                Save Review Site
            </button>
        </div>
    </div>
</div>

